import React, { FC } from "react";
import { Col, Row, Spin } from "antd";
import { Link } from "react-router-dom";

import long from "../assets/media/images/long.png";
import { IMagicPage } from "../models/magic-page";
import { MenuItem } from "./Layout/AppLayout/components/Footer";
import { MagicPagesTypes } from "../services/enums";
import { UIRoutes } from "../router";

interface IProps {
  data: IMagicPage;
  loading: boolean;
  children: React.ReactNode;
  title: string;
}

const AuthBase: FC<IProps> = ({ data, loading, title, children }) => {
  const links: MenuItem[] = [
    {
      name: "Copyright",
      segment: "copyright",
      id: MagicPagesTypes.Copyright,
    },
    {
      name: "Terms of Use",
      segment: "terms_conditions",
      id: MagicPagesTypes.Terms,
    },
    {
      name: "Privacy Policy",
      segment: "privacy_policy",
      id: MagicPagesTypes.PrivacyPolicy,
    },
    {
      name: "Advertising",
      segment: "advertising",
      id: MagicPagesTypes.Advertising,
    },
    {
      name: "Contact Us",
      segment: "contact",
      id: MagicPagesTypes.Contacts,
    },
    {
      name: "Press",
      segment: "press",
      id: MagicPagesTypes.Press,
    },
    {
      name: "Change Log",
      url: `/${UIRoutes.HOME_CHANGE_LOG}`,
      id: MagicPagesTypes.ChangeLogs,
    },
    //todo: uncomment when inplemented
    // {
    //   name: "Api",
    //   segment: "api",
    //   id: MagicPagesTypes.Api,
    // },
    // {
    //   name: "Widgets",
    //   segment: "widgets",
    //   id: MagicPagesTypes.Widgets,
    // },
  ];

  return (
    <div className="main-login main-login--fullscreen">
      <div className="main-login__header">
        <Row>
          <Col span={24}>
            <div className="main-login__header__logo">
              <div className="logo">
                <a href={"/"}>
                  <img src={long} alt="logo" />
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="main-login__block main-login__block--extended pb-0 mt-2">
        <Row>
          <Col span={24}>
            <div className="main-login__block__promo text-center">
              <h1 className="text-gray">
                {data?.title}
                {loading && <Spin size="large" />}
              </h1>
              <p className="text-gray">{data?.description}</p>
            </div>
            <div className="main-login__block__inner">
              <h4 className="text-uppercase fs-22 mb-4">
                <strong>{title}</strong>
              </h4>
              <div className="main-login__block__form">{children}</div>
              <div className="main-login__block__sidebar d-flex justify-content-center align-items-center text-gray h-100">
                {data?.content}
                {loading && <Spin size="large" />}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="main-login__footer text-center">
        <ul className="list-unstyled list-inline d-flex flex-wrap w-100 align-items-center justify-content-center">
          {links.map((el: MenuItem) => (
            <li className="list-inline-item" key={el?.id}>
              <Link
                to={
                  el.url
                    ? el.url
                    : `/${UIRoutes.VIEW_PAGE_BASE}/${el.segment}/${el.id}`
                }
              >
                {el.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div >
  );
};

export default AuthBase;
